module.exports = __webpack_public_path__ + "static/img/200228.6f82986f.png";